import { render, staticRenderFns } from "./lastUpdate.vue?vue&type=template&id=59acf54b&v-if=this.user.loggedIn"
import script from "./lastUpdate.vue?vue&type=script&lang=js"
export * from "./lastUpdate.vue?vue&type=script&lang=js"
import style0 from "./lastUpdate.vue?vue&type=style&index=0&id=59acf54b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports